import React from 'react'
import EstimationManagement from './abstract/EstimationManagement'
import PageHeader from '../../components/PageHeader'

import EstimationSheetTab from './EstimationEdit/EstimationSheetTab'

import EstimationActions from '../../libs/EstimationActions'

import LaborCostPrintTab from '../../print/LaborCostPrintTab'
import LaborUnitPricePrintTab from '../../print/LaborUnitPricePrintTab'
import MaterialCostPrintTab from '../../print/MaterialCostPrintTab'

import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'

class EstimationDetail extends EstimationManagement {
  componentWillMount () {
    const {params} = this.props.match
    const estimationId = params.estimationId
    EstimationActions.setEditableMode(false)
    this.loadEstimation(estimationId)
  }
  onPageMenuClicked (name) {
    const {params} = this.props.match
    const estimationId = params.estimationId
    switch (name) {
      case 'back':
        this.props.history.push('/company_user/estimation/' + this.estimationType)
        break
      case 'print':
        Window.alert('印刷専用の画面が開かれますので、通常のホームページを印刷するように、ブラウザの印刷機能で印刷してください。\n右クリック → ”印刷” より印刷の選択ができます。', () => {
          const link = document.createElement('a')
          link.target = '_blank'
          link.href = '/company_user/estimation/print/' + estimationId
          link.rel = 'noopener noreferrer'
          link.click()
          Window.closeDialog()
        })
        break
      case 'copy':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/copy/' + estimationId)
        break
      case 'edit':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/edit/' + estimationId)
        break
      case 'delete':
        Window.confirm('この見積書を削除してもよろしいでしょうか?', () => {
          this.deleteEstimation()
        })
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const pageHeaderMain = this.isTemplate ? '雛型' : '見積書'
    const pageHeaderSub = this.isTemplate ? 'こちらから雛型の作成・編集・削除ができます。' : 'こちらから標準見積書の作成・編集・削除ができます。'
    const estimationTitle = EstimationActions.getCurrentEstimation().estimationTitle

    return (
      <div>
        <PageHeader title={pageHeaderMain + ' - ' + estimationTitle} sub={pageHeaderSub} history={this.props.history}>
          <ul className='nav nav-pills kw-page-actions'>
            <li className='kw-btn-area'>
              <button onClick={(e) => this.onPageMenuClicked('back')} rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary'>
                <i className='icon-arrow-left icon-large' /><span>戻る</span>
              </button>
            </li>
            <li className='kw-btn-area'>
              <a onClick={(e) => this.onPageMenuClicked('copy')} rel='tooltip' data-placement='left' title='コピーまたは雛型作成' className='text-center kw-btn-success'>
                <i className='icon-share icon-large' /><span>再利用</span>
              </a>
            </li>
            <li className='kw-btn-area'>
              <a data-placement='left' title='印刷用ページを表示' className='text-center kw-btn-inverse' onClick={(e) => this.onPageMenuClicked('print')}>
                <i className='icon-print icon-large' /><span>印刷</span>
              </a>
            </li>
            <li className='kw-btn-area'>
              <a onClick={(e) => this.onPageMenuClicked('edit')} rel='tooltip' data-placement='left' title='新規見積書を編集' className='text-center kw-btn-success'>
                <i className='icon-edit icon-large' /><span>編集</span>
              </a>
            </li>
            <li className='kw-btn-area'>
              <a onClick={(e) => this.onPageMenuClicked('delete')} rel='tooltip' data-placement='left' title='新規見積書を削除' className='text-center kw-btn-danger'>
                <i className='icon-trash icon-large' /><span>削除</span>
              </a>
            </li>
          </ul>
        </PageHeader>
        <EstimationSheetTab isEditable={false} isPrintable={false} />
        <div style={{width: '307mm', margin: '0 auto'}}>
          <LaborCostPrintTab isEditable={false} />
          <MaterialCostPrintTab isEditable={false} />
          <LaborUnitPricePrintTab isEditable={false} />
        </div>
      </div>
    )
  }
}

export default EstimationDetail



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationDetail.js